var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classNames from 'classnames';
import { customCssClasses, getAriaAttributes, getDataAttributes, } from '@wix/editor-elements-common-utils';
import commonStyles from '../../Container/viewer/shared/common.scss';
import { ARIA_LABEL_DEFAULT, ARIA_LABEL_KEY, ARIA_LABEL_NAMESPACE, } from '../../Container/viewer/shared/constants';
import repeaterSemanticClassNames from '../../Repeater/Repeater.semanticClassNames';
import styles from './ResponsiveBox.scss';
const getAriaLabel = (translate) => {
    return translate
        ? translate(ARIA_LABEL_NAMESPACE, ARIA_LABEL_KEY, ARIA_LABEL_DEFAULT)
        : ARIA_LABEL_DEFAULT;
};
// This container is used in responsive site
const ResponsiveBox = (props, ref) => {
    const { id, className, containerRootClassName = '', customClassNames = [], children, role, onClick, onDblClick, onFocus, onBlur, onMouseEnter, onMouseLeave, hasPlatformClickHandler, translate, a11y = {}, ariaAttributes = {}, tabIndex, isRepeaterItem = false, } = props;
    const { 'aria-label-interactions': ariaLabelInteractions } = a11y, a11yAttr = __rest(a11y, ['aria-label-interactions']);
    if (ariaLabelInteractions) {
        a11yAttr['aria-label'] = getAriaLabel(translate);
    }
    const rootElementRef = React.useRef(null);
    React.useImperativeHandle(ref, () => {
        return {
            focus: () => {
                var _a;
                (_a = rootElementRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            },
            blur: () => {
                var _a;
                (_a = rootElementRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            },
        };
    });
    const getRootSemanticClassName = () => {
        if (isRepeaterItem) {
            return repeaterSemanticClassNames.repeaterItem;
        }
        if (props.semanticClassNames) {
            return props.semanticClassNames.root;
        }
        return '';
    };
    return (React.createElement("div", Object.assign({ id: id }, getDataAttributes(props), { ref: rootElementRef }, a11yAttr, getAriaAttributes(Object.assign(Object.assign({}, ariaAttributes), { tabIndex, role })), { className: classNames(styles.root, styles.resetDesignAttributes, containerRootClassName, className, {
            [commonStyles.clickable]: hasPlatformClickHandler,
        }, customCssClasses(...customClassNames, getRootSemanticClassName())), onDoubleClick: onDblClick, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }),
        React.createElement("div", { className: classNames(styles['css-background'], styles.bg, customCssClasses(...customClassNames, getRootSemanticClassName())) }),
        children() // contains: (1) ResponsiveContainer with relative children, (2) DynamicStructureContainer with pinned children
    ));
};
export default React.forwardRef(ResponsiveBox);
//# sourceMappingURL=ResponsiveBox.js.map